import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;

const Vehicle = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="ТС:">
      {getFieldDecorator('vehicle')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите ТС"
          allowClear={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          <Option key={1}>API не подключено</Option>
        </Select>
      )}
    </Form.Item>
  );
};

export default Vehicle;
